import { request, removeEmptyAttribute } from "../helpers/utility";

let instance = null;

export default class IncidentResources {
    constructor() {
        if (!instance) {
            this.url = 'admin/incidents';
            instance = this;
        }
        return instance;
    }

    get(id = null, params = {}) {
        let queryString = '';
        if (params && Object.keys(params).length > 0) {
            const queryParams = new URLSearchParams(params).toString();
            queryString = `?${queryParams}`;
        }

        if (id) {
            return request.GET(`${this.url}/${id}`)
        }
        return request.GET(`${this.url}${queryString}`)
    }

    post(body) {
        let post_body = { ...body };
        post_body = removeEmptyAttribute(post_body);
        return request.POST(this.url, post_body)
    }

    put(id, body) {
        let put_body = { ...body };
        return request.PUT(`${this.url}/${id}`, put_body)
    }

    delete(id) {
        return request.Fetch('DELETE', `${this.url}/${id}`, {}, false)
    }
}
